export const extrapayFlowDictEN = {
  extrapayFlowTitle: "Extrapay",
  extrapayFlowProgram: "EXTRAPAY | POINTS PROGRAM",
  extrapayFlowBannerTitle: "Your purchases open new possibilities.",
  extrapayFlowBannerSubtitle:
    "Earn points on purchases. Every 10 approved purchases, your points are converted into EXC.",
  extrapayFlowOpen: "Open Extrapay",
  extrapayFlowCyclePoints: "Cycle points",
  extrapayFlowPointsUnit: "points",
  extrapayFlowPointsAccumulated: "Earned on purchases in this cycle",
  extrapayFlowOrdersProgress: "{current} of {total} purchases",
  extrapayFlowCycleLabel: "Cycle {cycle}",
  extrapayFlowOnePurchaseLeft: "1 purchase left to complete the cycle.",
  extrapayFlowPurchasesLeft: "{count} purchases left to complete the cycle.",
  extrapayFlowCycleComplete: "Cycle complete. Conversion into EXC happens automatically.",
  extrapayFlowAccumulatedRate: "Accumulated conversion rate",
  extrapayFlowRateContinues: "It keeps accumulating in the next cycles",
  extrapayFlowPlatformBalance: "EXC BALANCE ON THE PLATFORM",
  extrapayFlowAvailableExternal: "Available to send to your external wallet.",
  extrapayFlowRequestWithdraw: "Request withdrawal",
  extrapayFlowLoadError: "Could not load Extrapay.",
  extrapayFlowRetry: "Try again",
  extrapayFlowPageSubtitle: "Track your points, EXC and withdrawal requests.",
  extrapayFlowPointsTitle: "EXTRAPAY POINTS",
  extrapayFlowCanRequest: "You can request {amount} EXC to your external wallet.",
  extrapayFlowRateNotice:
    "Your accumulated conversion rate is {rate}. It keeps accumulating in the next cycles.",
  extrapayFlowUnderstandRate: "Understand the rate",
  extrapayFlowTabPoints: "Points",
  extrapayFlowTabExc: "EXC",
  extrapayFlowTabWithdrawals: "Withdrawals",
  extrapayFlowOrigin: "Origin",
  extrapayFlowDate: "Date",
  extrapayFlowCycle: "Cycle",
  extrapayFlowPoints: "Points",
  extrapayFlowViewDetails: "View details",
  extrapayFlowPurchaseOrigin: "Purchase #{id}",
  extrapayFlowMovement: "Movement",
  extrapayFlowRequest: "Request",
  extrapayFlowSituation: "Status",
  extrapayFlowPointsEmpty: "No approved purchases found.",
  extrapayFlowExcEmpty: "Point conversions into EXC will appear here when a cycle is completed.",
  extrapayFlowWithdrawalsEmpty: "You have not requested any EXC withdrawals yet.",
  extrapayFlowPreviousCyclesEmpty: "Converted cycles will appear here.",
  extrapayFlowStatusRequested: "Requested",
  extrapayFlowStatusAwaiting: "Awaiting transfer",
  extrapayFlowStatusConfirmed: "Confirmed",
  extrapayFlowStatusConverted: "Converted",
  extrapayFlowStatusNotConverted: "Not converted",
  extrapayFlowStatusInProgress: "In progress",
  extrapayFlowStatusAccumulating: "Accumulating purchases",
  extrapayFlowKnowTitle: "Discover Extrapay",
  extrapayFlowKnowSubtitle: "See how your purchases generate points and an EXC balance on the platform.",
  extrapayFlowKnowProgram: "POINTS PROGRAM",
  extrapayFlowKnowHeading: "How Extrapay works",
  extrapayFlowKnowIntro:
    "Extrapay records points on purchases with approved payment. Every 10 purchases, those points are converted into Extracoin (EXC), which stays in your balance on the platform.",
  extrapayFlowStepPurchase: "APPROVED PURCHASE",
  extrapayFlowStepPurchaseNote: "after discounts · excluding shipping",
  extrapayFlowStepPurchasePoints: "+50 points",
  extrapayFlowStep1Label: "STEP 1 · POINTS",
  extrapayFlowStep1Title: "Points are added after payment",
  extrapayFlowStep1Body:
    "You receive points equal to 50% of the purchase amount after discounts. For example, a €100 purchase, excluding shipping, generates 50 points.",
  extrapayFlowStepCycle: "YOUR PURCHASE CYCLE",
  extrapayFlowStepCycleDone: "10 approved purchases",
  extrapayFlowStep2Label: "STEP 2 · CYCLE",
  extrapayFlowStep2Title: "Each cycle brings together 10 purchases",
  extrapayFlowStep2Body:
    "Each purchase with approved payment counts as one step. In Extrapay, you can see the points earned and how many purchases are left to complete the cycle.",
  extrapayFlowStepBalance: "BALANCE ON THE PLATFORM",
  extrapayFlowStepBalanceNote: "Credit after conversion",
  extrapayFlowStep3Label: "STEP 3 · CONVERSION",
  extrapayFlowStep3Title: "Points are converted into EXC",
  extrapayFlowStep3Body:
    "On the tenth purchase, the system multiplies the cycle points by your accumulated conversion rate. The result is credited as EXC to your platform balance.",
  extrapayFlowAfterConversionTitle: "What changes after conversion",
  extrapayFlowAfterConversionBody:
    "When the EXC credit is completed, the cycle points and the purchase counter return to zero. The conversion rate stays accumulated and will be used in the next cycles.",
  extrapayFlowBalanceSection: "BALANCE AND WITHDRAWAL",
  extrapayFlowWhereTitle: "Where the EXC you receive stays",
  extrapayFlowWhereBody:
    "EXC stands for Extracoin. After conversion, the amount is recorded on the platform. To receive it in an external crypto wallet, you need to request a withdrawal.",
  extrapayFlowOnPlatform: "On the platform",
  extrapayFlowYourExcBalance: "Your EXC balance",
  extrapayFlowOnExternalWallet: "In the external wallet",
  extrapayFlowSameExcAmount: "The same amount of EXC",
  extrapayFlowWithdrawPath:
    "When you request a withdrawal, enter the wallet address and the amount. The amount is deducted from the platform balance when you confirm. The team then sends the same amount of EXC to the address you provided.",
  extrapayFlowFaqTitle: "Details about the calculation and the withdrawal",
  extrapayFlowFaqSubtitle: "Select a question to read the explanation.",
  extrapayFlowFaqWhen: "How much EXC will I receive?",
  extrapayFlowFaqWhenAnswer:
    "The amount of EXC depends on two values: the points accumulated in the cycle and the accumulated conversion rate. That is why different cycles can generate different amounts of EXC.",
  extrapayFlowFaqWhenExampleLabel: "AN EXAMPLE",
  extrapayFlowFaqWhenExampleFormula: "500 points × 0.00070 rate = 0.35 EXC",
  extrapayFlowFaqWhenExampleNote:
    "In this example, there are 10 purchases of €100 after discounts, excluding shipping, using 18 Extracredits on each purchase and starting with a zero rate. Other purchases and rates can generate different amounts.",
  extrapayFlowFaqRate: "How does my conversion rate increase?",
  extrapayFlowFaqRateAnswer:
    "Each purchase adds 3 points to the rate calculation when there is no shipping, or 6 when there is shipping. The amount of Extracredit used is also added.",
  extrapayFlowFaqRateAnswer2:
    "This score is only used to calculate the rate; it is not added to the cycle points balance. The rate is the number used to convert points into EXC, not a fee charged. The system calculates and displays this number in Extrapay.",
  extrapayFlowFaqRateCalcTitle: "Full calculation",
  extrapayFlowFaqRateCalcLine1: "Accumulated rate = accumulated score for the rate ÷ 3 × 0.00001.",
  extrapayFlowFaqRateCalcLine2:
    "In the example: 10 × (3 + 18) = 210. The rate is 210 ÷ 3 × 0.00001 = 0.00070. Then, 500 points × 0.00070 = 0.35 EXC on the platform balance.",
  extrapayFlowFaqRateCalcLine3:
    "Cycle points correspond to 50% of the purchase amount after discounts. The rate has no defined limit or expiration.",
  extrapayFlowFaqWallet: "Do I need a crypto wallet to get started?",
  extrapayFlowFaqWalletAnswer:
    "No. Your EXC stays in the platform balance. You only need to provide the address of a wallet compatible with the Extracoin network when you want to request a withdrawal.",
  extrapayFlowFaqWalletAnswer2:
    "The Extrapay credit is not a transfer to the external wallet. That transfer happens after the request and is made by the team.",
  extrapayFlowKnowCtaTitle: "Check your cycle and your balance",
  extrapayFlowKnowCtaBody:
    "In Extrapay, you will find the points earned, the number of purchases and the EXC available.",
  extrapayFlowKnowCta: "View my Extrapay",
  extrapayFlowWithdrawTitle: "Token withdrawal",
  extrapayFlowWithdrawSubtitle: "Check your balance and follow your requests.",
  extrapayFlowWalletAddress: "Extracoin wallet address",
  extrapayFlowWalletAddressHint: "Copy the receiving address of your wallet on the Extracoin network.",
  extrapayFlowWithdrawAmount: "Withdrawal amount in EXC",
  extrapayFlowAvailableBalance: "Balance available on the platform: {amount} EXC.",
  extrapayFlowReviewWithdraw: "Review withdrawal",
  extrapayFlowHowYouReceive: "How you will receive it",
  extrapayFlowHowYouReceiveBody:
    "Extracoin will be sent to the wallet you provide. Check that the address belongs to you and is on the Extracoin network.",
  extrapayFlowHowYouReceiveDebit:
    "When you confirm, the amount is deducted from your EXC balance on the platform. The team will make the transfer afterwards.",
  extrapayFlowHowYouReceivePartial:
    "You can request part of the balance and follow each request in “My withdrawals”.",
  extrapayFlowDebitNotice: "The requested amount will be deducted from your EXC balance on the platform.",
  extrapayFlowAddressRequired: "Enter the wallet address.",
  extrapayFlowAmountRequired: "Enter an amount greater than zero.",
  extrapayFlowAmountAboveBalance: "The amount cannot be greater than the available balance.",
  extrapayFlowConfirmTitle: "Confirm your withdrawal",
  extrapayFlowConfirmSubtitle: "Review the address and the amount before confirming.",
  extrapayFlowYouReceive: "You will receive",
  extrapayFlowNetwork: "Network",
  extrapayFlowNetworkName: "Extracoin",
  extrapayFlowDestination: "Destination address",
  extrapayFlowPlatformDebit: "Deduction from the platform balance",
  extrapayFlowBalanceAfter: "Platform balance after the request",
  extrapayFlowConfirmCheck: "I have checked my wallet address and the withdrawal amount.",
  extrapayFlowConfirmNote:
    "When you confirm, the amount will be deducted from your EXC balance on the platform. The transfer to the external wallet will be made afterwards.",
  extrapayFlowConfirmAction: "Confirm withdrawal",
  extrapayFlowEditValues: "Edit address or amount",
  extrapayFlowSuccessTitle: "Request registered",
  extrapayFlowSuccessSubtitle: "The balance has been updated. Follow the transfer in the history.",
  extrapayFlowAvailableBalanceLabel: "Available balance",
  extrapayFlowAddress: "Address",
  extrapayFlowSuccessNote:
    "The team will transfer the amount to your wallet. Follow the update in “My withdrawals”.",
  extrapayFlowTrackWithdraw: "Track withdrawal",
  extrapayFlowMyWithdrawals: "My withdrawals",
  extrapayFlowWithdrawalsCrumb: "Withdrawals",
  extrapayFlowDetailsCrumb: "Details",
  extrapayFlowCycleCrumb: "Cycle details",
  extrapayFlowWithdrawDetailsTitle: "Withdrawal details {id}",
  extrapayFlowWithdrawDetailsSubtitle:
    "Your request has been registered and the amount has been deducted from the EXC balance on the platform.",
  extrapayFlowRequestDate: "Request date",
  extrapayFlowUser: "User",
  extrapayFlowWithdrawValue: "Withdrawal amount",
  extrapayFlowInformedAddress: "Address provided",
  extrapayFlowBackToWithdrawals: "Back to withdrawals",
  extrapayFlowWithdrawNotFound: "This request could not be found.",
  extrapayFlowCycleSubtitle: "Every 10 approved purchases, your points are converted into EXC.",
  extrapayFlowPurchases: "Purchases",
  extrapayFlowAccumulatedFee: "Accumulated rate",
  extrapayFlowPointsToConvert: "Points to convert",
  extrapayFlowCyclePointsTitle: "Cycle points",
  extrapayFlowViewPoints: "View points",
  extrapayFlowPreviousCycles: "Previous cycles and operations",
  extrapayFlowOperation: "Operation",
  extrapayFlowBackToExtrapay: "Back to Extrapay",
  extrapayFlowConversionTitle: "Cycle {cycle} conversion",
  extrapayFlowConversionFallback: "Conversion",
  extrapayFlowUnavailable: "—",
  extrapayFlowBasicData: "Basic details",
  extrapayFlowReference: "Reference",
  extrapayFlowQuantity: "Amount",
  extrapayFlowViewFullConversion: "View full conversion",
  extrapayFlowExcAmount: "{amount} EXC",
  extrapayFlowSignedExc: "+{amount} EXC",
  extrapayFlowSignedPoints: "+{amount}",
  extrapayFlowPurchasePointsTitle: "Purchase #{id} points",
  extrapayFlowPurchasePointsSubtitle: "See where the points from this entry came from.",
  extrapayFlowAmountAfterDiscount: "Amount after discount",
  extrapayFlowPointsPercent: "Percentage in points",
  extrapayFlowPointsPercentValue: "50%",
  extrapayFlowPointsReceived: "Points received",
  extrapayFlowPurchasePointsNote:
    "These points stay in the cycle balance until conversion after 10 purchases.",
  extrapayFlowOtpInvalid:
    "Invalid or expired verification code. Check your e-mail or request a new code.",
};
